import {routerBeforeEach} from '@/router/navigation.js'
import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes.js'

Vue.use(VueRouter)

let router = null

/**
 *
 * @returns {VueRouter}
 */
export function createRouter() {
  if (router === null) {
    router = new VueRouter({
      mode: 'history',
      base: process.env.BASE_URL,
      routes,
    })
  }
  router.beforeEach = routerBeforeEach

  return router
}

export {useRoute, useRouter} from 'vue-router/composables'

export default router
